export const PROCESS_SITUACAO = {
  1: { label: 'Aberto', tone: 'info', hint: 'O protocolo foi registrado e aguarda distribuição na fila do órgão.' },
  2: { label: 'Em análise', tone: 'warning', hint: 'A equipe técnica está avaliando o pedido, documentos e exigências.' },
  3: { label: 'Concluído', tone: 'success', hint: 'A análise foi encerrada. Consulte o órgão para retirar o despacho ou a licença.' },
  4: { label: 'Arquivado', tone: 'neutral', hint: 'O processo foi encerrado sem continuidade. Guarde o número para eventual reabertura.' },
};

export const PROCESS_TIPO = {
  1: 'Licenciamento ambiental',
  2: 'Alvará',
  3: 'Habite-se',
  4: 'Diversos',
};

export const COMPLAINT_STATUS = {
  1: { label: 'Recebida', tone: 'info', hint: 'O órgão registrou o relato. A equipe fará a triagem inicial.' },
  2: { label: 'Em análise', tone: 'warning', hint: 'A denúncia está sendo apurada pela fiscalização.' },
  3: { label: 'Atendida', tone: 'success', hint: 'A apuração foi concluída e as providências cabíveis foram tomadas.' },
  4: { label: 'Encaminhada', tone: 'info', hint: 'O caso foi enviado a outra área ou órgão competente.' },
  5: { label: 'Improcedente', tone: 'neutral', hint: 'Após análise, não se confirmou infração ambiental neste relato.' },
  6: { label: 'Não localizada', tone: 'neutral', hint: 'Não foi possível identificar o local ou a ocorrência descrita.' },
  7: { label: 'Em monitoramento', tone: 'warning', hint: 'O local segue acompanhado após a primeira vistoria.' },
  8: { label: 'Auto de infração', tone: 'danger', hint: 'Foi lavrado auto. Medidas administrativas estão em curso.' },
  9: { label: 'Arquivada', tone: 'neutral', hint: 'O procedimento foi encerrado e arquivado.' },
  10: { label: 'Enviada para arquivamento', tone: 'neutral', hint: 'A equipe propôs o arquivamento; aguarda confirmação.' },
  11: { label: 'Enviada ao jurídico', tone: 'info', hint: 'O caso está com a área jurídica do órgão.' },
  12: { label: 'Enviada ao gabinete', tone: 'info', hint: 'O relato foi encaminhado à chefia do órgão.' },
  13: { label: 'Enviada ao licenciamento', tone: 'info', hint: 'O caso foi associado a um processo de licença.' },
  14: { label: 'Notificação', tone: 'warning', hint: 'O responsável foi notificado e tem prazo para se manifestar ou regularizar.' },
  15: { label: 'Interditada', tone: 'danger', hint: 'A atividade no local foi interditada pelo órgão.' },
  16: { label: 'Embargada', tone: 'danger', hint: 'A obra ou atividade no local foi embargada pelo órgão.' },
};

export const UF_OPTIONS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
  'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
];

const TONE_CLASS = {
  info: 'bg-sky-50 text-sky-800 ring-sky-200',
  warning: 'bg-amber-50 text-amber-900 ring-amber-200',
  success: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  danger: 'bg-rose-50 text-rose-800 ring-rose-200',
  neutral: 'bg-slate-100 text-slate-700 ring-slate-200',
};

export function statusMeta(map, value, fallbackLabel) {
  const key = Number(value);
  const found = map[key];
  if (found) return { ...found, value: key };
  return {
    label: fallbackLabel || (value == null || value === '' ? 'Em andamento' : String(value)),
    tone: 'neutral',
    hint: 'Acompanhe este número neste órgão. Situações internas podem ter nomes próprios.',
    value: key || value,
  };
}

export function toneClass(tone) {
  return TONE_CLASS[tone] || TONE_CLASS.neutral;
}

export function formatPublicDate(value) {
  if (!value) return null;
  const raw = String(value);
  const iso = raw.length <= 10 ? `${raw}T12:00:00` : raw;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return raw.slice(0, 10);
  return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' }).format(date);
}

export function daysSince(value) {
  if (!value) return null;
  const raw = String(value);
  const date = new Date(raw.length <= 10 ? `${raw}T12:00:00` : raw);
  if (Number.isNaN(date.getTime())) return null;
  const diff = Math.floor((Date.now() - date.getTime()) / 86400000);
  if (diff < 0) return 0;
  return diff;
}

export function processTimeline(situacao) {
  const sit = Number(situacao) || 1;
  const steps = [
    { key: 1, label: 'Protocolado' },
    { key: 2, label: 'Em análise técnica' },
    { key: 3, label: sit === 4 ? 'Arquivado' : 'Concluído' },
  ];
  let current = 0;
  if (sit === 2) current = 1;
  if (sit === 3 || sit === 4) current = 2;
  return { steps, current };
}

export function complaintTimeline(status) {
  const st = Number(status) || 1;
  const steps = [
    { key: 1, label: 'Recebida' },
    { key: 2, label: 'Apuração' },
    { key: 3, label: 'Encaminhamento' },
    { key: 4, label: 'Encerrada' },
  ];
  let current = 0;
  if ([2, 7, 14].includes(st)) current = 1;
  if ([4, 10, 11, 12, 13].includes(st)) current = 2;
  if ([3, 5, 6, 8, 9, 15, 16].includes(st)) current = 3;
  return { steps, current };
}

export async function copyText(value) {
  if (!value) return false;
  try {
    await navigator.clipboard.writeText(String(value));
    return true;
  } catch {
    return false;
  }
}
